import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { isMyWorkAllowed } from "@/config/moduleAccess";

// Acesso ao módulo "Meu Trabalho" por allow-list de e-mail (ee013ee6).
//
// CONTRATO com o chamador: enquanto `isLoading` for true, trate como "não
// aparece". É o mesmo precedente anti-flash do PLANS_V32_LOCK_ENABLED em
// Modules.tsx (P0 #3 — paywall piscando em usuário Premium no primeiro
// paint): gate que resolve DEPOIS do primeiro paint pisca; gate deferido não.
export interface MyWorkAccess {
  allowed: boolean;
  isLoading: boolean;
}

export function useMyWorkAccess(): MyWorkAccess {
  const [state, setState] = useState<MyWorkAccess>({
    allowed: false,
    isLoading: true,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const {
          data: { user },
        } = await supabase.auth.getUser();
        if (cancelled) return;
        setState({ allowed: isMyWorkAllowed(user?.email), isLoading: false });
      } catch (err) {
        // Falha esperada com fallback real (módulo fica oculto) — warn (§11b).
        console.warn("[useMyWorkAccess] getUser failed:", err);
        if (!cancelled) setState({ allowed: false, isLoading: false });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
